<template>
  <div class="etapas configuracoes" :value="idPublicacao" :controlePage="controlePage">
    <div class="row innerPage">
      <div class="col-sm-6">
        <label>Selecione a conta para GRU Simples</label>
        <fcc-select
          class="mb-4"
          placeholder="Selecione uma GRU"
          labelField="nomefavorecido"
          v-model="contaBancaria"
          :options="listagemContas"
          required
          :disabled="controlePage.idsituacao === 4 || controlePage.gru != null"
          @change="alteraConta"
          :clearable="false"
        >
          Banco
        </fcc-select>
      </div>
      <div class="col-sm-6 plusConta">
        <button
          v-if="contaBancaria == null"
          v-b-tooltip.hover
          title="Adicionar GRU"
          @click="addField"
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon icon="plus" />
        </button>
        <button
          v-b-tooltip.hover
          v-if="controlePage.idsituacao != 4 && contaBancaria != null"
          :title="controlePage.idsituacao != 4 ? 'Editar GRU' : 'Ver GRU'"
          @click="
            controlePage.idsituacao != 4 ? editField(contaBancaria) : editField(contaBancaria, true)
          "
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon :icon="controlePage.idsituacao != 4 ? 'edit' : 'eye'" />
        </button>
        <template v-if="controlePage.idsituacao != 4 && contaBancaria != null">
          <button
            v-b-tooltip.hover
            title="Gerar Código Boleto"
            @click="gerarBoleto"
            class="btn btn-light border shadow-sm ml-2 text-dark"
          >
            <font-awesome-icon icon="file" />
          </button>
        </template>
        <template v-if="controlePage.idsituacao != 4 && contaBancaria != null">
          <button
            v-b-tooltip.hover
            title="Desvincular Conta"
            @click="clearField"
            class="btn btn-light border shadow-sm ml-2 text-dark"
          >
            <font-awesome-icon icon="eraser" />
          </button>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12"></div>
    </div>
    <fccModal
      centered
      size="xl"
      idModal="addFieldModal"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form autocomplete="off" @submit.prevent="criar.id === 0 ? addCnpj() : editarCnpj()">
        <div class="etapas configuracoes">
          <div class="borderForm innerPage">
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.id > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  minlength="14"
                  v-model="criar.cnpjcpf"
                  v-mask="cnpjMask"
                  >CNPJ<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-9">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.nomefavorecido"
                  >Nome da Unidade Favorecida<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-6">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.gestao"
                  >UG / Gestão<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-6">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.codigorecolhimento"
                  >Código de Recolhimento<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-6">
                <fcc-select
                  class="mb-4"
                  placeholder="Selecione um Banco"
                  labelField="banco"
                  valueField="id"
                  v-model="criar.idbanco"
                  :options="lstBancos"
                  required
                  :clearable="false"
                >
                  Banco
                </fcc-select>
              </div>
              <div class="col-sm-6">
                <fcc-select
                  class="mb-4"
                  placeholder="Selecione um tipo de pagamento"
                  labelField="tipopagamento"
                  valueField="id"
                  v-model="criar.idtipopagamento"
                  :options="lstFormaPagamento"
                  :disabled="tipopagamento != null"
                  required
                  :clearable="false"
                >
                  Tipo Acesso
                </fcc-select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.referencia"
                  >Serviço<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3 buttonSalvar">
              <div class="col-sm-12 text-right">
                <fccButton tipo="submit" :disabled="desabilitaInput"
                  ><font-awesome-icon icon="save" /> {{ labelsSystem.salvar }}</fccButton
                >
              </div>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      desabilitaInput: false,
      criar: {},
      textoPublicacao: 'Configurações da Publicação',
      tipoPublicacao: this.controlePage.idpublictipo,
      name: 'Selecione uma conta',
      titleModal: 'Nova GRU Simples',
      listagemContas: [],
      listarEndereco: [],
      lstBancos: [],
      idContaPublicacao: '',
      contaBancaria: null
    }
  },
  methods: {
    alteraConta() {
      this.$emit('alteraTipoPagamento', this.contaBancaria.id, this.contaBancaria, true)
    },
    listandoGru() {
      axios
        .get(
          this.baseUrlPublicacao + 'PublicacaoGRU/ListarPublicacaoGRU',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemContas = response.data
          this.contaBancaria = this.controlePage.gru
        })
        .catch(this.setErrorSystem)
    },
    addField() {
      this.criar.id = 0
      this.titleModal = 'Nova GRU Simples'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editField(contaBancaria, disabled = false) {
      this.criar = contaBancaria
      this.desabilitaInput = disabled
      this.titleModal = 'Editar GRU Simples'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    gerarBoleto() {
      this.callConfirm('Deseja gerar o CdBoleto ', 'da spi ' + this.controlePage.spi + ' ?').then(
        (result) => {
          if (result.value) {
            this.gerarCdBoletoPublicacao(this.idPublicacao).then(() => {
              this.callToast(this.mensagensUpdate.adicionado)
            })
          }
        }
      )
    },
    clearField() {
      this.callConfirm(
        'Deseja desvincular a conta ',
        'da spi ' + this.controlePage.spi + ' ?'
      ).then((result) => {
        if (result.value) {
          this.$emit('alteraTipoPagamento', 0, null, true)
        }
      })
    },
    editarCnpj() {
      this.criar.cnpjcpf = this.removeAcento(this.criar.cnpjcpf)
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlPublicacao + 'PublicacaoGRU/AlterarPublicacaoGRU',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGru()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.setErrorSystem(error)
          this.carregaTexto()
        })
    },
    addCnpj() {
      var criar = {
        id: 0,
        idbanco: this.criar.idbanco,
        idtipopagamento: this.criar.idtipopagamento,
        gestao: this.criar.gestao,
        competencia: '',
        codigofavorecido: '',
        codigorecolhimento: this.criar.codigorecolhimento,
        nomefavorecido: this.criar.nomefavorecido,
        codigocorrelacao: '',
        nomerecolhimento: '',
        cnpjcpf: this.removeAcento(this.criar.cnpjcpf),
        referencia: ''
      }
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoGRU/InserirPublicacaoGRU',
          criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((resposta) => {
          criar.id = resposta.data
          this.$emit('alteraTipoPagamento', resposta.data, criar, true)
          this.$root.$emit('bv::hide::modal', 'addFieldModal')

          setTimeout(() => {
            this.listandoGru()
            this.carregaTexto()
            this.$forceUpdate()
            this.callToast(this.mensagensUpdate.adicionado)
          }, 500)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.setErrorSystem(error)
          this.carregaTexto()
        })
    },
    listarBancos() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarBancosGenerico().then((resposta) => {
        this.lstBancos = resposta
        this.lstBancos = this.lstBancos.filter(function (banco) {
          return banco.banco.indexOf('GRU SIMPLES') != -1
        })
        this.carregaTexto()
      })
    }
  },
  props: {
    idPublicacao: Number,
    controlePage: Object,
    lstFormaPagamento: Array,
    tipopagamento: Object
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.criar.idtipopagamento = this.tipopagamento.id
    this.listandoGru()
    this.listarBancos()
  }
}
</script>
